module.exports = __webpack_public_path__ + "static/media/javascript.7e75af78.png";